import { DEFAULT_PER_PAGE } from '@/types/cars';

// Strip campaign labels after the proxy captures attribution cookies.
// Paid click IDs stay on the landing URL for ad-platform tag attribution.
const MULTI_SELECT = ['make', 'model', 'bodystyle', 'doors', 'cylinder', 'fuel',
  'engine', 'train', 'transmission', 'incolor', 'excolor'];

export function normalizeInventoryUrl(input: URL): URL {
  const url = new URL(input.href);
  const listing = url.pathname === '/cars' || /^\/cars\/collections\/[^/]+$/.test(url.pathname);
  const vehicle = /^\/cars\/[a-hj-npr-z0-9]{17}(?:\/history)?$/i.test(url.pathname);
  if (!listing && !vehicle) return url;

  const params = url.searchParams;
  params.delete('store');
  params.delete('mobile');
  for (const key of [...params.keys()]) {
    if (key.startsWith('utm_')) params.delete(key);
  }
  if (listing) {
    for (const key of MULTI_SELECT) {
      const values = params.getAll(key);
      if (!values.length) continue;
      params.delete(key);
      // Preserve the filter values themselves, including whitespace/case.
      for (const value of [...new Set(values)].sort()) params.append(key, value);
    }
    if (params.getAll('page').length === 1 && /^0*1$/.test(params.get('page') || '')) params.delete('page');
    if (params.has('limit')) {
      const limits = params.getAll('limit');
      if (limits.length === 1 && /^[1-9]\d*$/.test(limits[0]!) && !params.has('perPage')) {
        params.set('perPage', limits[0]!);
        params.delete('limit');
      }
    }
    if (!params.has('limit') && params.getAll('perPage').length === 1 && params.get('perPage') === String(DEFAULT_PER_PAGE)) {
      params.delete('perPage');
    }
    // These backend compatibility fields are derived from sort by the server.
    if (params.getAll('sort').length === 1 && params.get('sort')) {
      params.delete('orderBy');
      params.delete('orderAsc');
    }
    // Stable key order; repeated range values keep their original order.
    params.sort();
  }
  return url;
}

export function inventoryPageHref(pathname: string, search: URLSearchParams, page: number): string {
  const url = new URL(pathname, 'https://thiscar.com');
  url.search = search.toString();
  // Acquisition tags belong to the landing visit, not every pagination link.
  for (const key of [...url.searchParams.keys()]) {
    if (key.startsWith('utm_') || ['gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'ttclid', 'li_fat_id'].includes(key)) {
      url.searchParams.delete(key);
    }
  }
  url.searchParams.set('page', String(page));
  const normalized = normalizeInventoryUrl(url);
  return normalized.pathname + normalized.search;
}
